import { Injectable } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import {Observable} from 'rxjs';
import { AuthenticationService } from '../services/authentication.service';


@Injectable()
// inject the authentication service

export class AuthGuard implements CanActivate {


    constructor(private router: Router, private authenticationservice: AuthenticationService) { }

    canActivate(): boolean {


        if (!this.authenticationservice.isAuthenticated()) {

            this.router.navigate(['login']);
            return false;
        }
        return true;
    }



}
